import { Link } from "react-router-dom";


export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-slate-50 font-body flex items-center justify-center px-4 py-10">
    <div className="w-full max-w-md">
      <div className="flex flex-col items-center text-center mb-8">
        <img src="/logo-insieme.png" alt="Logo Insieme" className="h-36 w-36 object-contain" data-testid="auth-logo" />
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
        <h1 className="font-heading text-2xl font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1 text-[15px]">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
      <p className="text-center text-xs text-slate-500 mt-6">Insieme · gestione associazioni<br /><span data-testid="auth-copyright">© {new Date().getFullYear()} Opale Group</span> · <Link to="/note-legali" data-testid="auth-legal-link" className="underline hover:text-slate-600">Privacy e note legali</Link></p>
    </div>
  </div>
);
